import { Dispatch } from 'redux'
import { ActionType, CommonAction } from './actionTypes'
import { Localidad, Provincia } from '../../../services/gob-ar'

export const setProvinces = (provinces: Provincia[]) => {
    return (dispatch: Dispatch<CommonAction>) => {
        dispatch({
            type: ActionType.SET_PROVINCES,
            payload: provinces
        })
    }
}

export const setLocalities = (localities: Localidad[]) => {
    return (dispatch: Dispatch<CommonAction>) => {
        dispatch({
            type: ActionType.SET_LOCALITIES,
            payload: localities
        })
    }
}
